import React from 'react';
import { string } from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import classNames from 'classnames';
import { pathOr } from 'ramda';

import { propTypes } from '../../util/types';
import { DataWithLabel } from '../../components';

import css from './BookingParticipantBreakdown.module.css';

const BookingParticipantBreakdown = (props) => {
  const {
    className,
    intl,
    transaction,
  } = props;
  const adultCount = pathOr(0, ['attributes', 'protectedData', 'quantity', 'adults'], transaction);
  const childCount = pathOr(0, ['attributes', 'protectedData', 'quantity', 'children'], transaction);
  const infantCount = pathOr(0, ['attributes', 'protectedData', 'quantity', 'infants'], transaction);
  const adultText = intl.formatMessage({ id: 'Marketplace.adultCount' }, { count: adultCount });
  const childText = intl.formatMessage({ id: 'Marketplace.childCount' }, { count: childCount });
  const infantText = intl.formatMessage({ id: 'Marketplace.infantCount' }, { count: infantCount });
  const value = [
    ...adultCount ? [adultText] : [],
    ...childCount ? [childText] : [],
    ...infantCount ? [infantText] : []
  ];
  const participantsLabelText = intl.formatMessage({ id: 'BookingParticipantBreakdown.participantsLabel' });
  const classes = classNames(css.root, className);

  return (
    <DataWithLabel className={classes} label={participantsLabelText} value={value} />
  )
}

BookingParticipantBreakdown.defaultProps = {
  className: null,
};

BookingParticipantBreakdown.propTypes = {
  className: string,
  intl: intlShape.isRequired,
  transaction: propTypes.transaction.isRequired,
};

export default injectIntl(BookingParticipantBreakdown);